export enum ClientType {
    Person = 'person',
    Company = 'company',
}
